import api from './api';

export const clientesService = {
  listar: (q = '', page = 0, size = 25) =>
    api.get('/clientes', { params: { q, page, size, sort: 'apellidos' } }),

  obtener: (id) =>
    api.get(`/clientes/${id}`),

  crear: (data) =>
    api.post('/clientes', data),

  actualizar: (id, data) =>
    api.put(`/clientes/${id}`, data),

  eliminar: (id) =>
    api.delete(`/clientes/${id}`),
};
